<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="有效日期" prop="time"><br>
				<el-date-picker style="width: 100%;" v-model="inputmodel.end_time" type="date" placeholder="选择日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
				</el-date-picker>
			</el-form-item>

			<el-form-item label="状态" prop="status"><br>
				<el-radio v-model="inputmodel.status" label="1">启用</el-radio>
				<el-radio v-model="inputmodel.status" label="0">禁用</el-radio>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		couponspecies_create
	} from "@/api/api.js"
	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '优惠券',
					model: 'name'
				}, {
					name: '描述',
					model: 'describe'
				}, {
					name: '金额',
					model: 'amount'
				}, {
					name: '发放数量',
					model: 'num'
				}],
				inputmodel: {
					name: '',
					describe: '',
					amount: '',
					num: '',
					end_time: '',
					status: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
				},
			}
		},
		methods: {
			qx(i) {
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							couponspecies_create(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})

							console.log(this.inputmodel);
						}
					})
				} else {
					this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};

		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>